import moment from "moment";
import React, { useState, useMemo, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import SignatureCanvas from "react-signature-canvas";
import SignaturePad from "./SignaturePad";
import { FLIGHT_STATUS } from "../../../constants";
import RatingMilestonePopup from "./RatingMilestonePopup";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../hooks/app";
import { getUser } from "../../../store/slices/auth-slice";

function StepFour({ request, setFile }: { request: any, setFile: any }) {
  const [activeTab, setActiveTab] = useState(2);
  const user = useAppSelector(getUser)
  const [show, setShow] = useState<boolean>(false);
  const { getRootProps, getInputProps, open, isFocused, acceptedFiles } =
    useDropzone({
      noClick: true,
      noKeyboard: true,
    });

  useEffect(() => {
    if (acceptedFiles.length) {
      setFile(acceptedFiles[0])
    }
  }, [acceptedFiles])

  useEffect(() => {
    if (activeTab === 2) {
      setFile(null)
    }
  }, [activeTab])

  const baseStyle: any = {
    flex: 1,
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fff",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const focusedStyle = {
    borderColor: "#000 !important",
  };

  const style: any = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
    }),
    [isFocused]
  );
  const BASE_URL = process.env.REACT_APP_API_PROTOCOL + "://" + process.env.REACT_APP_API_HOST
  return (
    <div className="signature_step__two">
      <div className="input_group text-left">
        <div className="mb-2 d-flex flex-column align-items-start">
          <label>Request ID: </label>
          <h3 className="heading3">{request?._id}</h3>
        </div>

        {
          request?.flights?.length ? <>
            <div className="mb-2 d-flex flex-column align-items-start">
              <label>Flights to sign: </label>
              {request?.flights?.map((f: any) => (
                <Link to={`/logbook/flights/view_flight/${f?._id}`} key={f?._id} style={{ color: "inherit" }}>
                  <h3 className="heading3">{f?.flightNumber}</h3>
                </Link>
              ))}
            </div>
          </> : request?.endorsement?._id ? <>
            <div className="mb-2 d-flex flex-column align-items-start">
              <label>Endorsement to sign: </label>
              <h3 className="heading3">{request?.endorsement?.name}</h3>
            </div>
            <div className="mb-2 d-flex flex-column align-items-start">
              <label>Certificate No: </label>
              <h3 className="heading3">{request?.endorsement?.certificateNo}</h3>
            </div>
            <div className="mb-2 d-flex flex-column align-items-start">
              <label>Entry Date: </label>
              <h3 className="heading3">{moment(request?.endorsement?.entryDate).format("DD MMMM YYYY")}</h3>
            </div>
            <div className="mb-2 d-flex flex-column align-items-start">
              <label>Expiry Date: </label>
              <h3 className="heading3">{moment(request?.endorsement?.expiryDate).format("DD MMMM YYYY")}</h3>
            </div>
          </> : request?.ratingType ? <>
            <div className="mb-2 d-flex flex-column align-items-start">
              <label>Rating To Sign: </label>
              <h3 className="heading3">Type <b>{request?.ratingType}</b> and model <b>{request?.ratingModal}</b></h3>
              {show && <RatingMilestonePopup studentId={request?.createdBy?._id} type={request?.ratingType} modal={request?.ratingModal} setShow={setShow} />}
              <button className="btn btn-primary" onClick={(e) => { e.preventDefault(); setShow(true) }}>View Milestones</button>
            </div>
          </> : null}

        <div className="mb-2 d-flex flex-column align-items-start">
          <label>Student Name: </label>
          <h3 className="heading3">{request?.createdBy?.firstname} {request?.createdBy?.lastname}</h3>
        </div>

        <div className="d-flex flex-column align-items-start">
          <label>Request Date: </label>
          <h3 className="heading3">{moment(request?.createdAt).format("DD MMMM YYYY")}</h3>
        </div>

        <div className="d-flex flex-column align-items-start">
          <label>Status: </label>
          {request?.status === FLIGHT_STATUS.APPROVED &&
            <h4 className="badge p-2 bg-success">Approved</h4>
          }

          {request?.status === FLIGHT_STATUS.PENDING &&
            <h4 className="badge p-2 bg-warning">Pending</h4>
          }

          {request?.status === FLIGHT_STATUS.CANCELLED &&
            <h4 className="badge p-2 bg-danger">Cancelled</h4>
          }
          {request?.signature && <div className="mb-2 d-flex flex-column align-items-start">
            <label>Signature: </label>
            <img src={`${BASE_URL}/uploads/signatures/${request?.signature}`} width={200} />
          </div>
          }
        </div>
      </div>

      {request?.status == 0 && <>
        <h3 className="heading3 my-3 mb-1">Signature</h3>
        <span style={{ color: "red" }}><small>* new signature will be updated for all users</small></span>
        <div className="tabs">
          <span
            className="tab upload "
            style={{ borderBottomColor: activeTab === 2 ? "#00AF80" : "#EFF6FF" }}
            onClick={() => setActiveTab(2)}
          >
            Default
          </span>
          <span
            className="tab draw"
            style={{ borderBottomColor: activeTab === 0 ? "#00AF80" : "#EFF6FF" }}
            onClick={() => setActiveTab(0)}
          >
            Draw
          </span>
          <span
            className="tab upload "
            style={{ borderBottomColor: activeTab === 1 ? "#00AF80" : "#EFF6FF" }}
            onClick={() => setActiveTab(1)}
          >
            Upload
          </span>

        </div>
        <div className="text-left my-3">
          <div className="tab_content">
            {activeTab === 2 && (
              <img src={`${BASE_URL}/uploads/signatures/${user?.signature}`} width={200} />
            )}
            {activeTab === 1 && (
              <div {...getRootProps({ className: "dropzone", style })}>
                <input {...getInputProps()} />
                <h3
                  className="heading3 my-3 text-center"
                  style={{ color: "#000" }}
                >
                  {acceptedFiles?.length ? (
                    acceptedFiles[0].name
                  ) : (
                    <span>
                      Drop Backup Files Here <br />
                      <small
                        className="d-block pt-2 "
                        style={{ color: "#808080" }}
                      >
                        or
                      </small>
                    </span>
                  )}
                </h3>
                <button
                  type="button"
                  style={{
                    borderRadius: 6,
                    outline: "none",
                    padding: "6px 20px 6px 20px",
                    color: "#000",
                    background: "#EEEEEE",
                    border: "1px solid #808080",
                  }}
                  onClick={open}
                >
                  Select Files
                </button>
              </div>
            )}

            {activeTab === 0 && (
              <SignaturePad setFile={setFile} />
            )}
          </div>
        </div>
      </>}
    </div>
  );
}

export default StepFour;
